import { getMediaDevices } from '@gem/call/Removable/packages/deviceInfo/deviceInfo';
import { t } from '@gem/modules/i18n';
import { popupsTasks } from '@gem/popups';

import { hasMicrophonePermission } from './hasMicrophonePermission';

export const hasAudioPermissions = async (checkMicrophone = true): Promise<boolean> => {
  const { hasSpeaker } = await getMediaDevices();

  if (!hasSpeaker) {
    popupsTasks.showAlert(t('calls_no_dynamic_connected'));

    return false;
  }

  if (!checkMicrophone) {
    return true;
  }

  return await hasMicrophonePermission();
};
